<div id="matDialogContent" class="dialog">
  <div id="bestellschlussnachricht" *ngIf="data.data.kunde">
    <strong>Bestellschlussnachricht</strong>
    <br>
    <span [innerHtml]="data.data.kunde.einrichtung.info | bbCode"></span>
  </div>
  <div id="speiseplanPdf" *ngIf="(data.data.pdf | json) != '{}'" (click)="openPDF()" class="dialog-buttons">
    <strong>Anhänge</strong>
    <div>
      <mat-icon>picture_as_pdf</mat-icon>
      <span>Speiseplan PDF</span>
    </div>
  </div>
</div>
